import styled from '@emotion/styled';
import { Variables } from '../../../base/variables';
import * as Shared from '../form.styles';

export const FormContainer = styled(Shared.FormContainer)`
    position: relative;
`;
export const FormGrid = Shared.FormGrid;
export const FormField = Shared.FormField;
export const Label = Shared.Label;
export const Input = Shared.Input;
export const Select = Shared.Select;
export const ErrorMessage = Shared.ErrorMessage;
export const AutocompleteContainer = Shared.AutocompleteContainer;
export const AutocompleteDropdown = Shared.AutocompleteDropdown;
export const AutocompleteOption = Shared.AutocompleteOption;
export const LoadingText = Shared.LoadingText;
export const NoResults = Shared.NoResults;

